import React, { useState, useEffect } from "react";
import './Navi.css'
import { Button, ButtonGroup, Container, Flex, HStack, Image, Menu, MenuButton, MenuItem, MenuList, Text } from "@chakra-ui/react";
import ToffeeTitle from "../toffee-title.svg";
import { Link, useNavigate } from "react-router-dom";
import { useAuthStore } from "../stores/authStore";
import TokenService from "../service/tokenService";
import { AtSignIcon, ChevronDownIcon, NotAllowedIcon } from "@chakra-ui/icons";

function Navi(props) {
    const [isFixed, setFixed] = useState(false);
    const threshold = 0;
    const navigate = useNavigate();
    function handleScroll(e) {
        if (document.documentElement.scrollTop > threshold) {
            setFixed(true);
        } else {
            setFixed(false);
        }
    }
    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const { user } = useAuthStore();

    const handleLogout = () => {
        TokenService.logout();
    }

    return (
        <div
            id={"navi"}
            className={`navi ${isFixed ? 'sticky' : ''}`}
        >
            <Container
                maxW={"7xl"} paddingY={2} paddingX={8}
            >
                <Flex minW={"max-content"} alignContent={"center"} justify={"space-between"} gap={"2"}>
                    <HStack align={"center"} spacing={6}>
                        <Link to={`/`}>
                            <Image
                                htmlWidth={150}
                                src={ToffeeTitle}
                            />
                        </Link>
                        <ButtonGroup alignContent={"center"} spacing={4}>
                            <Link to={`listen`}>
                                <Button
                                    size={"lg"}
                                    variant={"ghost"}
                                >Listening</Button>
                            </Link>
                            <Link to={`speak`}>
                                <Button
                                    size={"lg"}
                                    variant={"ghost"}
                                >Speaking</Button>
                            </Link>
                            <Link to={`read`}>
                                <Button
                                    size={"lg"}
                                    variant={"ghost"}
                                >Reading</Button>
                            </Link>
                            <Link to={`write`}>
                                <Button
                                    size={"lg"}
                                    variant={"ghost"}
                                >Writing</Button>
                            </Link>
                        </ButtonGroup>
                    </HStack>
                    {!!user ? (
                        <HStack align={"center"} spacing={2}>
                            <Menu>
                                <MenuButton as={Button} colorScheme='teal' variant='ghost' rightIcon={<ChevronDownIcon />}>
                                    <Text fontSize={"xl"}>{user.nickname}</Text>
                                </MenuButton>
                                <MenuList>
                                    <MenuItem icon={<AtSignIcon />} onClick={() => {
                                        navigate('/profile');
                                    }}>
                                        Profile
                                    </MenuItem>
                                    <MenuItem icon={<NotAllowedIcon />} onClick={() => {
                                        handleLogout();
                                    }}>
                                        Logout
                                    </MenuItem>
                                </MenuList>
                            </Menu>
                        </HStack>
                    ) : (
                        <HStack align={"center"} spacing={2}>
                            <Link to={'/signup'}>
                                <Button
                                variant={"ghost"}
                                colorScheme={"pink"}
                                >
                                    Signup
                                </Button>
                            </Link>
                            <Link to={'/login'}>
                                <Button
                                variant={"outline"}
                                colorScheme={"pink"}
                                >
                                    Login
                                </Button>
                            </Link>
                        </HStack>
                    )}
                </Flex>
            </Container>
        </div>
    );
}

export default Navi;